<div class="usage-skeleton" role="status" aria-busy="true">
  <div class="usage-skeleton__card" *ngFor="let _ of placeholders">
    <div class="usage-skeleton__line usage-skeleton__line--title"></div>
    <div class="usage-skeleton__bar"></div>
    <div class="usage-skeleton__line usage-skeleton__line--meta"></div>
  </div>
</div>
